import { cn } from "../../utils/cn";

interface CloseButtonProps {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  "aria-label"?: string;
}

// The focus ring is a box-shadow (drawn outside the box) rather than a border, so focusing the
// button never changes its size — no layout shift, and an adjacent scrollbar cannot clip it.
const buttonStyles =
  "inline-flex items-center justify-center p-1 rounded-full outline-none " +
  "text-loch " +
  "hover:bg-loch-50 " +
  "focus-visible:shadow-[0_0_0_1px] focus-visible:shadow-loch " +
  "active:bg-loch-100";

export const CloseButton = ({
  onClick,
  className,
  iconClassName,
  "aria-label": ariaLabel = "Close",
}: CloseButtonProps) => {
  return (
    <button type="button" className={cn(buttonStyles, className)} onClick={onClick} aria-label={ariaLabel}>
      <i
        className={cn(
          "fa-sharp fa-regular fa-xmark text-[20px] size-5 flex items-center justify-center",
          iconClassName,
        )}
        aria-hidden="true"
      />
    </button>
  );
};
